import useEventListener from './useEventListener';

function useOnClickOutside({ ref, handler, initialEnabled }) {
    return useEventListener({
        initialEnabled: initialEnabled,
        eventName: 'mouseup',
        handler(e) {
            const el = ref?.current

            // Do nothing if clicking ref's element or descendent elements
            if (!el || el.contains(e.target)) {
                return;
            }

            handler(e);
        }
    });
}

export default useOnClickOutside;